var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import { LazyLoadImage, } from 'react-lazy-load-image-component';
import { makeStyles } from '@material-ui/core/styles';
import { mergeClasses } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
    avatar: {},
    image: {
        objectFit: 'cover',
    },
}));
const LazyAvatar = (_a) => {
    var { src, alt, lazyOptions = {}, classes: newClasses = {}, avatarClasses = {} } = _a, props = __rest(_a, ["src", "alt", "lazyOptions", "classes", "avatarClasses"]);
    const baseClasses = useStyles();
    const classes = mergeClasses({
        Component: LazyAvatar,
        baseClasses,
        newClasses,
    });
    return (React.createElement(Avatar, Object.assign({ className: classes.avatar, classes: avatarClasses }, props),
        React.createElement(LazyLoadImage, Object.assign({ className: classes.image, src: src, width: '100%', height: '100%', alt: alt }, lazyOptions))));
};
export default LazyAvatar;
